<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div >
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="核查状态" >
              <a-radio-group v-model="queryParam.status" size="small">
                <a-radio-button value="">
                  全部
                </a-radio-button>
                <a-radio-button value="2">
                  通过
                </a-radio-button>
                <a-radio-button value="1">
                  未通过
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="操作状态" >
              <a-radio-group v-model="queryParam.opStatus" size="small">
                <a-radio-button value="">
                  全部
                </a-radio-button>
                <a-radio-button value="0">
                  未操作
                </a-radio-button>
                <a-radio-button value="1">
                  已操作
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-button size="small" type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button size="small" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            <a-button size="small" type="primary" @click="ignoreHandle" style="margin-left: 32px">忽略核查结果</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="small"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
           <a @click="view(record)">查看</a>
           <!--<a-dropdown>-->
            <!--<a class="ant-dropdown-link">操作 <a-icon type="down" /></a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item>-->
                <!--<a @click="">查看</a>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'VoiceDataPatientList',
    mixins:[JeecgListMixin],
    props:{
      voiceBatchId:{
        type:String,
        default:'',
      }
    },
    data(){
      return {
        columns: [
          {
            title: '编号',
            align:"center",
            width:100,
            dataIndex: 'patient.patientNum'
          },
          {
            title: '姓名',
            align:"center",
            width:100,
            dataIndex: 'patient.name'
          },
          {
            title: '核查状态',
            align:"center",
            width:100,
            dataIndex: 'status',
            customRender:(value,row,index)=>{
              if(value !=='0' && value){
                return  value==='2'?'通过':'未通过'
              }else{
                return '-'
              }
            }
          },
          {
            title: '题目数量',
            align:"center",
            width:100,
            dataIndex: 'formItemNum'
          },
          {
            title: '通过率(%)',
            align:"center",
            width:100,
            dataIndex: 'formItemPassRate'
          },
          {
            title: '操作状态',
            align:"center",
            width:100,
            dataIndex: 'opStatus',
            customRender:(value,row,index)=>{
              let result = ''
              switch (value) {
                case '0':
                  result = '未修改'
                  break
                case '1':
                  result = '已修改'
                  break
              }
              return result
            }
          },
          {
            title: '操作',
            align:"center",
            width:60,
            scopedSlots: {customRender: 'action'},
          },
        ],
        url: {
          list: "/voice/voiceApplyForm/list",
        },
      }
    },
    watch:{
      voiceBatchId(){
        this.loadDataMy()
      }
    },
    mounted(){
      this.loadDataMy()
    },
    methods:{
      ignoreHandle(){
        if(this.selectedRowKeys.length==0){
          return this.$message.warning('请选择至少一条数据。');
        }
        this.$confirm({
          title: '确认忽略核查结果',
          content: '是否确认忽略核查结果？',
          onOk:()=> {
            postAction('/voice/voiceApplyForm/ignores',{ids:this.selectedRowKeys.join(',')}).then(res=>{
              if(res.success){
                this.loadData()
              }
            })
          },
        });

      },
      loadDataMy(){
        if(!this.voiceBatchId){
          return
        }
        this.baseQueryParam = {voiceBatchId:this.voiceBatchId}
        this.loadData()
      },
      view(record){
        this.$router.push({
          path:'/project/datacheck/voiceItem/'+ record.id
        })
      }
    }
  }
</script>

<style scoped>

</style>